<template>
  <div class="grid">
    <div class="logo">
      <a href="https://www.computus.nl/holding">
        <img src="/computus_logo.png" class="logo" alt="Logo Computus Holding B.V." title="Computus.nl" />
      </a>
    </div>

    <div class="nav">
      <ul>
        <li><router-link :to="{name: 'holdingcontact'}">Contact</router-link></li>
        <li><router-link :to="{name: 'home'}">Computus B.V.</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "header",
  components: {}
};
</script>

<style scoped>
.logo {
  width: 300px;
  grid-area: headerleft;
}

.nav {
    width: 300px;
    
    grid-area: headerright;
}

.nav ul {
    text-align: right;
    list-style-type: none;
}

.nav a {
  text-decoration: none;
}

.nav a:hover {
  text-decoration: underline;
}

.grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 300px auto 300px;
  grid-template-areas: "headerleft . headerright";
}
</style>